import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-center',
  styleUrl: 'center.css',
  shadow: false,
})
export class Center {
  @Prop() max: string = "var(--measure)";
  @Prop() gutters: string = "var(--s0)";
  @Prop() andtext: boolean = false;
  @Prop() intrinsic: boolean = false;

  render() {
    return (
      <div class={`cwru-center ${this.andtext ? "center" : ""} ${this.intrinsic ? "intrinsic" : ""}`} style={{'--gutters': this.gutters, '--max': this.max}}>
        <div>
          <slot />
        </div>
      </div>
    );
  }
}
